import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import BulkMasterPart from "./BulkMasterPart";
import { usePostAllMasterInventoryMutation } from "../../../Services/inventory/Inventory";
import useThemeColors from "../../vehicle/ThemeColors";
import './styles.scss'
import { Loader } from "react-bootstrap-typeahead";

interface IPROPS {
    closeModal: any;
    refetch: any;
}

const AddMasterParts: React.FC<IPROPS> = ({ closeModal, refetch }) => {
    const [inventoryName, setInventoryName] = useState("");
    const [hsn, setHsn] = useState("");
    const [price, setPrice] = useState("");
    const [gst, setGst] = useState("");
    const [partId, setPartId] = useState("");
      const [showAccountButton, setShowAccountButton] = useState(true);
      const [loading, setLoading] = useState(false)
      const [submitted, setSubmitted] = useState(false);

    


    const [addInventoryTrigger, {status}] = usePostAllMasterInventoryMutation();


    useEffect(() => {
        if (status === "pending") {
            setLoading(true)

        }
        else {
            setLoading(false)
        }

    }, [status])

    const saveHandler = async (e) => {
        e.preventDefault();
            setSubmitted(true);

           if (!inventoryName || !hsn || !price || !gst || !partId) {
        toast.error("Please fill all required fields");

        return;
    }
        const inventoryAddPayload = {
            inventoryName: inventoryName,
            hsnCode: hsn,
            price_per_unit: price,
            gst: gst,
            partId
        };

        const response = await addInventoryTrigger(inventoryAddPayload);

        try {
            if (response?.data) {
                toast.success("Inventory added successfully");
                refetch();
                closeModal();
                    setSubmitted(false);

            } else if ("data" in response?.error) {
                const errorData = response.error.data as { hsnCode?: string[] };

                if (errorData?.hsnCode?.length) {
                    toast.error(errorData.hsnCode[0]);
                } else {
                    toast.error("Something went wrong");
                    setSubmitted(false);

                }            }
        } catch (error) {
            console.log(error);
                    setSubmitted(false);

        }
        console.log(response, "responsee");
    };

    const handleSwitchToggle = () => {
        setShowAccountButton(!showAccountButton);
      };

            const {
                selectedColor,
                selectedBackgroundColor,
                selectedBorderColor,
                selectedButtonBackgoundColors,
                selectedButtonColors,
            } = useThemeColors();

            const closeHandler = () => {
                closeModal()
            }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "10px" }}>


              <div
                className="vehicle-info-middle"
                // style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
            >
                <div className="vehicle-info-middle-heading" style={{fontSize: "20px", display: "flex", justifyContent: "center"}}>Add part</div>
                <div
                    className="vehicle-info"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <div style={{ width: "100%" }}>
                        <p className="vehicle-class">
                            <span className="required" style={{ paddingLeft: "10px" }}>Part Name</span>
                            <span>
                                <input
                                    style={{
                                        borderRadius: "20px",
                                        background: "#FCFCFC",
                                                border: submitted && !inventoryName ? "1px solid red" : "1px solid #ced4da",

                                    }}
                                    className="form-control"
                                    type="text"
                                    onChange={(e) =>
                                        setInventoryName(e.target.value)
                                    }
                                    value={inventoryName}
                                    placeholder="Part name"
                                />
                            </span>
                        </p>
                    </div>

                      <div>
                <label className="required">HSN code</label>
                <input
                style={{borderRadius: "30px",                                                 border: submitted && !hsn ? "1px solid red" : "1px solid #ced4da",
}}
                placeholder="HSN code..."
                    className="form-control form-control-solid"
                    onChange={(e) => setHsn(e.target.value)}
                    value={hsn}
                />
            </div>

            <div>
                <label className="required">Part number</label>
                <input
                style={{borderRadius: "30px", 
border: submitted && !partId ? "1px solid red" : "1px solid #ced4da",
                    
                }}
placeholder="Part number..."
                    className="form-control form-control-solid"
                    onChange={(e) => setPartId(e.target.value)}
                    value={partId}
                />
            </div>
            <div>
                <label className="required">Price</label>
                <input
                style={{borderRadius: "30px", border: submitted && !price ? "1px solid red" : "1px solid #ced4da",}}
                placeholder="Price..."

                    className="form-control form-control-solid"
                    onChange={(e) => setPrice(e.target.value)}
                    value={price}
                />
            </div>
            <div>
                <label className="required">GST</label>
                <input
                style={{borderRadius: "30px", border: submitted && !gst ? "1px solid red" : "1px solid #ced4da",}}
placeholder="GST..."
                    className="form-control form-control-solid"
                    onChange={(e) => setGst(e.target.value)}
                    value={gst}
                />
            </div>

                    <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
                          <button
                          className="btn btn-secondary"
                          style={{  border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",}}
                            onClick={closeHandler}
                            // disabled={!brandName.trim()}
                            // style={{
                            //     background:  `${selectedButtonBackgoundColors}`,
                            //     color: `${selectedButtonColors}`,
                            //     border: "none",
                            //     padding: "10px 20px",
                            //     borderRadius: "20px",
                            //     fontSize: "15px",
                            // }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={saveHandler}
                            // disabled={!brandName.trim()}
                            style={{
                                background:  `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
                            }}
                        >
                            {loading ? <>Saving...<Loader /></> : "Save"}
                        </button>
                    </div>
                </div>
            </div>



            {/* Upper one is correct */}

{/* <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <label
            className="form-check-label mx-2"
            style={{
              fontSize: "16px",
              color: showAccountButton ? "#009ef7" : "",
            }}
          >
            Single
          </label>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={handleSwitchToggle}
              checked={!showAccountButton}
            />
          </div>
          <label
            className="card-text"
            style={{
              fontSize: "16px",
              color: !showAccountButton ? "#009ef7" : "",
            }}
          >
            Bulk
          </label>
        </div> */}

         {/* {!showAccountButton && (
                <BulkMasterPart
                dynamicData={"dynamicData"}
                closeModal={closeModal}
                refetch={"refetchingData"}
                teamAndAccountData={"teamAndAccountData"}
               
                />
              )}

              {showAccountButton && 

              <div>

        
            <div>
                <label>Inventory Name</label>
                <input
                    className="form-control form-control-solid"
                    type="text"
                    onChange={(e) => setInventoryName(e.target.value)}
                    value={inventoryName}
                />
            </div>
            <div>
                <label>HSN code</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setHsn(e.target.value)}
                    value={hsn}
                />
            </div>

            <div>
                <label>Part id</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setPartId(e.target.value)}
                    value={partId}
                />
            </div>
            <div>
                <label>Price</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setPrice(e.target.value)}
                    value={price}
                />
            </div>
            <div>
                <label>GST</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setGst(e.target.value)}
                    value={gst}
                />
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                }}
            >
                <button className="btn btn-danger" onClick={closeModal}>Cancel</button>
                <button className="btn btn-primary" onClick={saveHandler}>
                    {" "}
                    Save
                </button>
            </div>
            </div>
            } */}

        </div>
    );
};

export default AddMasterParts;
